import { Routes, Route } from 'react-router-dom';
import PledgeReleaseCaseList from './pages/PledgeReleaseCaseList';
import PledgeReleaseCaseForm from './pages/PledgeReleaseCaseForm';
import PledgeReleaseCaseDetails from './pages/PledgeReleaseCaseDetails';
import GoldReceiptForm from './pages/GoldReceiptForm';
import GoldReceiptDetails from './pages/GoldReceiptDetails';

function PledgeReleaseCaseRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PledgeReleaseCaseList />} />
      <Route path="/create" element={<PledgeReleaseCaseForm />} />
      <Route path="/edit/:id" element={<PledgeReleaseCaseForm />} />
      <Route path="/gold-receipt/create" element={<GoldReceiptForm />} />
      {/* Correcting an existing receipt — only reachable with an approved
          reconciliation on the case; the form itself enforces that. */}
      <Route path="/gold-receipt/edit" element={<GoldReceiptForm />} />
      <Route path="/gold-receipt/view" element={<GoldReceiptDetails />} />
      <Route path="/:id" element={<PledgeReleaseCaseDetails />} />
    </Routes>
  );
}

export default PledgeReleaseCaseRoutes;
